<template>
  <div class="change-password">
    <form @submit.prevent="changePassword">
      <input
        type="password"
        minlength="7"
        required
        placeholder="New password"
        v-model="changePasswordForm.password"
      >

      <input
        type="password"
        minlength="7"
        required
        placeholder="Confirm password"
        v-model="changePasswordForm.confirmPassword"
      >

      <br>

      <button type="submit" :disabled="running">Submit</button><br><br>

      <p class="error" v-show="error">
        There was a problem updating your password. Please try again later.
      </p>

      <p class="error" v-show="mismatch">Passwords do not match</p>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      changePasswordForm: {
        password: '',
        confirmPassword: '',
      },
      running: false,
      mismatch: false,
      error: false,
    };
  },

  methods: {
    changePassword() {
      if (!this.running) {
        this.running = true;

        if (this.changePasswordForm.password === this.changePasswordForm.confirmPassword) {
          this.mismatch = false;
          const user = this.$firebase.auth().currentUser;

          user.updatePassword(this.changePasswordForm.confirmPassword)
            .then(() => {
              this.reset();

              this.$toast({ message: 'Password successfully changed' });
              this.$emit('changedPassword');
            })
            .catch(() => {
              this.reset();

              this.$toast({ message: 'Didn\'t save password, try again', error: true });
            });
        } else {
          this.mismatch = true;
          this.running = false;
        }
      }
    },

    reset() {
      this.running = false;
      this.changePasswordForm.password = '';
      this.changePasswordForm.confirmPassword = '';
    },
  },
};
</script>
